
import { defineComponent } from "vue";
import LNavbar from "@/components/LNavbar/LNavbar.vue";
import { mapActions, mapMutations, mapState } from "vuex";
import { getLinks } from "./api/crud";
import { removeLocalStorage } from "./helpers/setLocalStore";

export default defineComponent({
  name: "App",
  components: { LNavbar },
  methods: {
    ...mapMutations(["updateSateFromStorage", "setLinks", "clearVuex"]),
    ...mapActions(["getLInksRequest"]),
  },
  computed: {
    ...mapState(["token"]),
  },
  created() {
    this.updateSateFromStorage();
    // Realizat peticion con token de localstorage, siempre se tiene que hacer.
    // tanto si es valido o no, si tiene.
    // si la peticoin es correcta redirigir a /home
    // si retorna un error elimiar localStorage y dejar en login/registro ruta
    if (this.token.length > 0) {
      // peticion con el token
      getLinks(this.token).then((res) => {
        if (!res.user) {
          // bad request, elimiar local sorage and state/vuex
          removeLocalStorage();
          this.clearVuex();
          this.$router.push("/");
          return;
        }
        // el usuario y token son correctos
        this.setLinks(res.user.links);
        this.$router.push("/home");
      });
    }
  },
});
